import React, {Component} from 'react';
import axios from 'axios';
import {FaCircle, FaCloud, FaServer} from "react-icons/fa";
import { connect } from 'react-redux';
import { Spinner } from 'react-bootstrap';
import { Card, CardBody, CardHeader, Table } from 'reactstrap';
import BreadcrumbCustomer from "../../../components/Layout/user/BreadcrumbCustomer";
import ModalComponent from "../../ModalComponent";

class DetailVpsUsComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loadPage: true,
            error: false,
            messageError: '',
            btnSubmit: true,
            vps: {},
            isNotification: false,
            textNotification: '',
            isModal: false,
            titleModal: '',
            modalBody: '',
            action: '',
            isBtnConfirm: true,
            contentModal: '',
            btnConfirmDisabled: false,
            isSpinner: false,
            actionKey: 0,
            alert: {
                error: false,
                message: ''
            },
            changeDomain: '',
            changePassword: '',
            strengPass: 0,
            errorNotification: '',
            messageErrorNotification: '',
            billingCycle: ''
        }
    }

    componentDidMount() {
        // this.props.updateUrlRedirect({ url: window.location.href })
        window.scrollTo(0, 0);
        this.getDetailVps(this.props.vpsId);

        this.setState({
            errorNotification: this.props.errorNotificationUser,
            messageErrorNotification: this.props.messageErrorNotificationUser,
        })
        // console.log(this.props.errorNotificationUser);
        // console.log(this.props.successNotificationUser);
        if (this.props.errorNotificationUser) {
            this.props.updateErrorNotiUser({
                error: false,
                message: ''
            });
        }
    }

    getDetailVps = (vpsId) => {
        let dataAuth = {
            username: process.env.REACT_APP_CLIENT_ID,
            password: process.env.REACT_APP_CLIENT_PASSWD,
            token: process.env.REACT_APP_KEY,
        };

        axios.get( process.env.REACT_APP_API_URL + '/api/vps-us/getDetailVps/' + vpsId,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization' : this.props.token,
                    'dataAgency' : JSON.stringify(dataAuth)
                }
            }
        )
            .then( (ref) => {
                // console.log(ref.data);
                this.setState({
                    loadPage: false,
                    isLoading: false,
                });
                if (ref.data.error === 0) {
                    this.setState({
                        vps: ref.data.vps,
                    })
                } else {
                    if (ref.data.error > 9000) {
                        this.props.logOut();
                    }
                    else if ( ref.data.error > 8000 ) {
                        this.redirectBack(ref.data.message);
                    }
                    else {
                        this.setState({
                            error: true,
                            messageError: ref.data.message,
                        })
                    }
                }
                // console.log(this.state.perPage);
            })
            .catch( (error) => {
                console.log(error);
                this.setState({
                    loadPage: false,
                    isLoading: false,
                    error: true,
                    messageError: 'Lấy dữ liệu đơn đặt hàng thất bại',
                })
            })
    }

    redirectBack = (message) => {
        this.props.notification({
            isNotification: true,
            textNotification: message
        });
        this.props.redirectBack();
    }

    showModal = (key, action) => {
        let titleModal;
        let modalBody;
        if ( action === 'delete' ) {
            titleModal = 'Hủy dịch vụ VPS US';
            modalBody = this.modalBody(key, action);
        }
        else if ( action === 'expire' ) {
            titleModal = 'Gia hạn dịch vụ VPS';
            modalBody = this.modalBody(key, action);
        }
        this.setState({
            action: action,
            isModal: true,
            btnConfirmDisabled: false,
            contentModal: {
                modalBody: modalBody,
                title: titleModal
            },
            isBtnConfirm: true,
            isSpinner: false,
        })
    }

    modalBody = (key, action) => {
        if ( action === 'delete' ) {
            return (
                <div className="text-center">
                    Bạn có muốn hủy dịch vụ VPS US <b className="text-danger">(ip: { this.state.vps.ip })</b> này không?
                </div>
            )
        }
        else if ( action === 'expire' ) {
            return (
                <div className="text-center">
                    Bạn có muốn gia hạn dịch vụ VPS US <b className="text-danger">(ip: { this.state.vps.ip })</b> này không?
                </div>
            )
        }
        else if ( action === 'finish_expire' ) {
            return (
                <div className="text-center">
                    Yêu cầu gia hạn VPS thành công. Quý khách vui lòng bấm <a href="/" className="btn btn-sm btn-primary" onClick={ () => this.redirectDetailOrder() }> vào đây </a> để thanh toán hoàn thành quá trình gia hạn.
                </div>
            )
        }
        else if ( action === 'confirm_expire' ) {
            return (
                <div className="text-center">
                    <label htmlFor="choose_vps">Chọn thời gian gia hạn</label>
                    <select className="form-control text-center" name="billingCycle" id="billingCycle" onChange={this.changeInput} defaultValue={this.state.billingCycle}>
                        {
                            key.map( (billingCycle, keyBc) => (
                                <option value={ billingCycle.id } key={keyBc}>{ billingCycle.value }</option>
                            ))
                        }
                    </select>
                </div>
            )
        }
    }

    redirectDetailOrder = () => {
        let link = "/don-dat-hang/" + this.state.orderId + "/chi-tiet-don-dat-hang.html";
        this.hiddenModal();
        window.open(link, '_blank');
    }

    hiddenModal = () => {
        this.setState({
            action: '',
            isModal: false,
        })
    }

    confirmModal = () => {
        if ( this.state.action === 'finish_expire' ) {
            let link = "/don-dat-hang/" + this.state.orderId + "/chi-tiet-don-dat-hang.html";
            window.open(link, '_blank');
            this.hiddenModal();
        }
        else {
            let listVps = [];

            this.setState({
                btnConfirmDisabled: true,
                isSpinner: true,
                isBtnConfirm: false,
                alert: {
                    error: false,
                    message: ''
                }
            })
            let dataAuth = {
                username: process.env.REACT_APP_CLIENT_ID,
                password: process.env.REACT_APP_CLIENT_PASSWD,
                token: process.env.REACT_APP_KEY,
            };
            let form = {
                vpsId: this.state.vps.id,
                action: this.state.action,
                billingCycle: this.state.billingCycle,
                os: this.state.os,
                listVps: listVps
            };

            axios.put( process.env.REACT_APP_API_URL + '/api/vps-us/action', form,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization' : this.props.token,
                        'dataAgency' : JSON.stringify(dataAuth)
                    }
                }
            )
                .then( (ref) => {
                    // console.log(ref.data);
                    this.setState({
                        isSpinner: false,
                    });
                    if ( ref.data.error > 9000 ) {
                        this.props.logOut();
                    }
                    else if ( ref.data.error ) {
                        this.setState({
                            contentModal: {
                                modalBody: this.modalBodyConfirm(ref.data.error,ref.data.message),
                                title: this.state.contentModal.title
                            },
                        })
                    }
                    else {
                        if ( this.state.action === 'rebuild' ) {
                            let titleModal = 'Yêu cầu cài đặt lại VPS US';
                            let modalBody = this.modalBody( ref.data.content , 'rebuild_chosse_vps');
                            this.setState({
                                btnConfirmDisabled: false,
                                contentModal: {
                                    modalBody: modalBody,
                                    title: titleModal
                                },
                                os: ref.data.content[0].id,
                                isBtnConfirm: true,
                                isSpinner: false,
                                action: 'rebuild_chosse_vps'
                            })
                        }
                        else if ( this.state.action === 'expire' ) {
                            let titleModal = 'Yêu cầu gia hạn VPS US';
                            let modalBody = this.modalBody( ref.data.content , 'confirm_expire');
                            this.setState({
                                btnConfirmDisabled: false,
                                contentModal: {
                                    modalBody: modalBody,
                                    title: titleModal
                                },
                                billingCycle: ref.data.content[0].id,
                                isBtnConfirm: true,
                                isSpinner: false,
                                action: 'confirm_expire',
                                orderId: 0
                            })
                        }
                        else if ( this.state.action === 'confirm_expire' ) {
                            let titleModal = 'Yêu cầu gia hạn VPS US';
                            let modalBody = this.modalBody( ref.data.content , 'finish_expire');
                            this.setState({
                                btnConfirmDisabled: false,
                                contentModal: {
                                    modalBody: modalBody,
                                    title: titleModal
                                },
                                isBtnConfirm: true,
                                btnPayment: true,
                                isSpinner: false,
                                action: 'finish_expire',
                                orderId: ref.data.content
                            })
                        }
                        else {
                            if ( !ref.data.error ) {
                                window.scrollTo(0, 0);
                                this.getDetailVps(this.props.vpsId);
                            }
                            this.setState({
                                contentModal: {
                                    modalBody: this.modalBodyConfirm(ref.data.error,ref.data.message),
                                    title: this.state.contentModal.title
                                },
                            })
                        }
                    }
                    // console.log(this.state.perPage);
                })
                .catch( (error) => {
                    console.log(error);
                    this.setState({
                        isSpinner: false,
                        contentModal: {
                            title: this.state.contentModal.title,
                            modalBody: this.modalBodyConfirm(1, 'Thực hiện hành động không thành công')
                        },
                    })
                })
        }
    }

    modalBodyConfirm = (error, message) => {
        if ( error ) {
            return (
                <div className="text-center text-danger">
                    { message }
                </div>
            )
        } else {
            return (
                <div className="text-center text-success">
                    { message }
                </div>
            )
        }
    }

    changeInput = (event) => {
        let name = event.target.name;
        let value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
        this.setState({
            [name]: value
        });
    }

    render() {
        return (
            <>
                {
                    this.state.loadPage ? (
                        <div className="cr-page-spinner load-page">
                            <Spinner animation="border" variant="primary"/>
                        </div>
                    ) : (
                        <>
                            <BreadcrumbCustomer title={"Chi tiết VPS US"} page={"VPS US"} icon={<FaCloud className="breadcrumb-icon"/>} />
                            <Card>
                                <CardHeader>
                                    <h3 className="card-title">Thông tin dịch vụ / sản phẩm</h3>
                                </CardHeader>
                                <CardBody className="row product-details clearfix">
                                    <div className="col-md-6 mb-4">
                                        <div className={ "product-status product-status-" + this.state.vps.status_vps }>
                                            <div className="product-icon text-center">
                                                <span className="fa-stack fa-lg">
                                                    <FaCircle className="fa-stack-2x" />
                                                    <FaServer className="fa-stack-1x fa-inverse" />
                                                </span>
                                                <h3>VPS { this.state.vps.text_config }</h3>
                                                <h4>VPS US</h4>
                                            </div>
                                            <div className="product-status-text">
                                                { this.state.vps.text_status_vps }
                                            </div>
                                        </div>
                                        <div className="row mt-4">
                                            {
                                                this.state.vps.status_vps === 'on' || this.state.vps.status_vps === 'off' ||
                                                this.state.vps.status_vps === 'expire' ? (
                                                    <>
                                                        <div className="col-md-12 max-with-70">
                                                            <button type="button" className="btn btn-block btn-danger" onClick={ () => this.showModal(0, 'delete') }>Hủy dịch vụ</button>
                                                        </div>
                                                        <div className="col-md-12 max-with-70 mt-1">
                                                            <button type="button" className="btn btn-block btn-success" onClick={ () => this.showModal(0, 'expire') }>Gia hạn dịch vụ</button>
                                                        </div>
                                                    </>
                                                ) : (
                                                    <></>
                                                )
                                            }
                                        </div>
                                    </div>
                                    <div className="col-md-6 text-center info-services">
                                        <Table className="table table-sm table-bordered">
                                            <tbody>
                                                <tr>
                                                    <td>Ngày tạo</td>
                                                    <td>{ this.state.vps.text_created_at }</td>
                                                </tr>
                                                <tr>
                                                    <td>Chi phí</td>
                                                    <td>{ this.state.vps.text_amount } ₫</td>
                                                </tr>
                                                <tr>
                                                    <td>Thời gian thuê</td>
                                                    <td>{ this.state.vps.text_billing_cycle }</td>
                                                </tr>
                                                <tr>
                                                    <td>Ngày hết hạn</td>
                                                    <td>{ this.state.vps.text_next_due_date }</td>
                                                </tr>
                                                <tr>
                                                    <td>Hình thức thanh toán</td>
                                                    <td>Thanh toán bằng số dư tài khoản</td>
                                                </tr>
                                            </tbody>
                                        </Table>
                                        <hr style={{ 'border-top': '1px dashed rgb(133 133 133)' }}/>
                                        <Table className="table table-sm table-bordered">
                                            <tbody>
                                                <tr>
                                                    <td className="text-left font-weight-bold text-center" colSpan="2">Thông tin chi tiết</td>
                                                </tr>
                                                <tr>
                                                    <td>IP</td>
                                                    <td>{ this.state.vps.ip }</td>
                                                </tr>
                                                <tr>
                                                    <td>Thời gian thuê</td>
                                                    <td>{ this.state.vps.text_billing_cycle }</td>
                                                </tr>
                                                <tr>
                                                    <td>Username</td>
                                                    <td>{ this.state.vps.username }</td>
                                                </tr>
                                                <tr>
                                                    <td>Password</td>
                                                    <td>{ this.state.vps.password }</td>
                                                </tr>
                                                <tr>
                                                    <td>Hệ điều hành</td>
                                                    <td>{ this.state.vps.text_os }</td>
                                                </tr>
                                                <tr>
                                                    <td>Bang</td>
                                                    <td>{ this.state.vps.state }</td>
                                                </tr>
                                                <tr>
                                                    <td>Cấu hình</td>
                                                    <td>{ this.state.vps.text_config }</td>
                                                </tr>
                                            </tbody>
                                        </Table>
                                    </div>
                                </CardBody>
                            </Card>
                            {/*<Card className="mt-4">*/}
                            {/*    <CardHeader>*/}
                            {/*        <h3 className="card-title">*/}
                            {/*            Thông tin hoạt động*/}
                            {/*        </h3>*/}
                            {/*    </CardHeader>*/}
                            {/*    <CardBody className="row mb-4">*/}
                            {/*        <Table className="table table-sm table-bordered table-hover rounded text-center">*/}
                            {/*            <thead>*/}
                            {/*                <tr>*/}
                            {/*                    <td>Hành động</td>*/}
                            {/*                    <td>Trạng thái</td>*/}
                            {/*                    <td>Thời gian</td>*/}
                            {/*                </tr>*/}
                            {/*            </thead>*/}
                            {/*            <tbody>*/}
                            {/*                { this.loadLogActivity() }*/}
                            {/*            </tbody>*/}
                            {/*        </Table>*/}
                            {/*    </CardBody>*/}
                            {/*</Card>*/}
                            <ModalComponent
                                isModal={ this.state.isModal }
                                content={this.state.contentModal}
                                isBtnConfirm={ this.state.isBtnConfirm }
                                isSpinner={ this.state.isSpinner }
                                btnConfirmDisabled={ this.state.btnConfirmDisabled }
                                hiddenModal={ () => this.hiddenModal() }
                                confirmModal={ () => this.confirmModal() }
                                alert={ this.state.alert }
                            />
                        </>
                    )
                }
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.login.token,
        user: state.user.user,
        credit: state.user.credit,
        isNotification: state.adminMain.isNotification,
        textNotification: state.adminMain.textNotification,
        errorNotificationUser: state.notificationUser.errorNotificationUser,
        messageErrorNotificationUser: state.notificationUser.messageErrorNotificationUser,
        successNotificationUser: state.notificationUser.successNotificationUser,
        messageSuccessNotificationUser: state.notificationUser.messageSuccessNotificationUser,
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        logOut: () => {
            dispatch(({ type : 'logOut', page: 'CustomerDetailVpsUs' }))
        },
        notification: (item) => {
            dispatch(({ type : 'notification', item }))
        },
        updateCredit: (item) => {
            dispatch(({ type : 'updateCredit', item }))
        },
        updateUrlRedirect: (item) => {
            dispatch(({ type : 'updateUrlRedirect', item }))
        },
        updateSuccessNotiUser: (item) => {
            dispatch(({ type : 'updateSuccessNotiUser', item }))
        },
        updateErrorNotiUser: (item) => {
            dispatch(({ type : 'updateSuccessNotiUser', item }))
        },
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(DetailVpsUsComponent);